import { LeadType } from '@utils/types';

export enum BlueconicDialogues {
  AppDownload = 'appDownload',
  Paywall = 'paywall',
  CustomUrlModal = 'customUrlModal',
  NewsletterModal = 'newsletterModal',
  LeadCaptureModal = 'leadCaptureModal',
  LeadCaptureModalWithVerticalArticles = 'leadCaptureModalWithVerticalArticles',
  LeadCaptureModalWithNewsletters = 'leadCaptureModalWithNewsletters',
  LeadCaptureModalWithNewsletter = 'leadCaptureModalWithNewsletter',
  LeadCaptureModalWithHorizontalArticles = 'leadCaptureModalWithHorizontalArticles',
  LeadCaptureModalWithSingleArticle = 'leadCaptureModalWithSingleArticle',
  LeadCaptureModalWithMultipleSubscribeOptions = 'leadCaptureModalWithMultipleSubscribeOptions',
  LeadCaptureModalWithSplitImg = 'leadCaptureModalSplitImg',
  PersonalizedReadingHub = 'personalizedReadingHub',
  StickyBannerBottom = 'stickyBannerBottom',
}

export interface BlueconicProps {
  customUrl?: string;
  dialogueType: BlueconicDialogues;
  name?: string;
}

export interface BlueconicNewsletterModalProps extends BlueconicProps {
  newsletterName: string;
  newsletterDescription: string;
  frequency: string;
  newsletterId: number;
  authors: string;
  redirectUri?: string;
  buttonText?: string;
  leadType: string;
  highlight?: string;
}

export interface BlueconicPaywallProps extends BlueconicProps {
  title: string;
  subtitle?: string;
  offerLink: string;
  buttonText?: string;
  leadType?: LeadType;
}

export interface BlueconicStickyBannerBottomProps extends BlueconicProps {
  title: string;
  buttonText: string;
  redirectUri: string;
  loggedInButtonText: string;
}

export interface BlueconicCustomUrlModalProps extends BlueconicProps {
  title: string;
  subtitle: string;
  disclosure: string;
  buttonText: string;
  highlight?: string;
}

export interface BlueconicAppDownloadModalProps extends BlueconicProps {
  dialogueType: BlueconicDialogues;
}

export interface BlueconicLeadCaptureModalProps extends BlueconicProps {
  buttonText: string;
  disclosure?: string;
  highlight?: string;
  leadType: string;
  offerCode?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicLeadCaptureModalHorizontalArticlesProps extends BlueconicProps {
  articleSlugs: string[];
  buttonText: string;
  leadType: string;
  offerCode?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicLeadCaptureModalVerticalArticlesProps extends BlueconicProps {
  articleSlugs: string[];
  articleTitleSection?: string;
  buttonText: string;
  highlight?: string;
  leadType: string;
  offerCode?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicLeadCaptureModalSingleArticleProps extends BlueconicProps {
  highlight?: string;
  articleSlug: string;
  buttonText: string;
  leadType: string;
  offerCode?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicLeadCaptureModalSplitImgProps extends BlueconicProps {
  buttonText: string;
  highlight?: string;
  imgPathLarge: string;
  imgPathMedium: string;
  imgPathSmall: string;
  leadButtonText?: string;
  leadHighlight?: string;
  leadType: string;
  offerCode?: string;
  subtitle?: string;
  title?: string;
}

export interface BlueconicLeadCaptureModalWithNewslettersProps extends BlueconicProps {
  newsletterIds: number[];
  title: string;
  subtitle: string;
  buttonText: string;
  leadButtonText: string;
  leadType: string;
  offerCode: string;
}

export interface BlueconicLeadCaptureModalWithNewsletterProps extends BlueconicProps {
  newsletterId: number;
  subtitle: string;
  buttonText: string;
  leadType: string;
  offerCode: string;
  newsletterImageUrl?: string;
}

export interface BlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps extends BlueconicProps {
  buttonText: string;
  highlight?: string;
  leadType: string;
  title: string;
  subtitle: string;
  proOfferCode: string;
  annualOfferCode: string;
}

export interface BlueconicPersonalizedReadingHubProps extends BlueconicProps {
  articlesRead: string;
  favoriteAuthors: string[];
  minutesRead: string;
  mostReadNewsletters: string[];
  mostReadTopic: string;
  mostReadTopics: string[];
  recommendedArticles: string[];
  recommendedAuthors: string[];
  recommendedNewsletters: string[];
  trendingTopics: string[];
  userId: string;
}
